<template>
  <DatatableReportV3
    id="memberships-sold-table"
    title="Memberships To-Do"
    download-url="/reports/memberships"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import CustomerMembershipLink from "@/MembershipModal/CustomerMembershipLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import WorkItemToggle from "@/Reports/WorkItemToggle.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "sold_on",
            title: "Sold On"
          },
          {
            data: "invoice",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices
          },
          { data: "job" },
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers
          },
          { data: "program" },
          {
            data: "systems",
            searchable: false,
            className: "text-center",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.systems
          },
          {
            data: "department",
            filterName: "department_id",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments
          },
          {
            data: "technician",
            title: "Owner",
            filterName: "technician_id"
          },
          {
            data: "completed",
            title: "Complete",
            className: "text-center",
            searchable: false,
            orderable: false
          }
        ],
        vueComponents: [
          {
            rootId: "customer-membership-link-vue",
            component: CustomerMembershipLink,
            options: {
              store
            }
          },
          {
            rootId: "work-item-toggle-vue",
            component: WorkItemToggle,
            options: {
              store
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
